<template>
    <v-layout row wrap> 
        <v-flex xs12 sm6>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Name :
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{basic_info.firstName}} {{basic_info.middleName}} {{basic_info.lastName}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Employee Id : 
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                {{basic_info.employeeId}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Email : 
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{basic_info.email}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Cellphone : 
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{cellPhone}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Gender : 
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{basic_info.gender}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Civil Status : 
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{commonfn.getStatusDescription(basic_info.civilStatus)}}
                </v-flex>  
            </v-layout>
        </v-flex>
        <v-flex xs12 sm6>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Address :
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{address_info.addressLine1}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Zip Code :
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{address_info.zipCode}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    City :
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{address_info.city}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Province :
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{address_info.province}}
                </v-flex>  
            </v-layout>
            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                <v-flex xs4 class="text-xs-left">
                    Birth Date :
                </v-flex>
                <v-flex xs8 class="font-weight-bold text-xs-left">
                    {{basic_info.birthDate|moment('MMM DD, YYYY')}}
                </v-flex>  
            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>
import commonfn from '@/common/functions'
export default {
    components: {},
    data() {
        return {
            error: false,
            errorMsg: null,
        }
    },
    props: ['basic_info', 'address_info'],
    methods: {},
    created() {
        this.commonfn = commonfn
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        cellPhone() {
            if (this.basic_info.phone!=null)
                return `+63-${this.basic_info.phone.substring(2,5)}-${this.basic_info.phone.substring(5,12)}`
        },
    },
}
</script>
<style scoped>
    .section-layout {
        padding:0px 20px 0px 50px;
    }
    .section-layout-mobile {
        padding:0px 0px 0px 5px;
    }
</style>